import Container from "@material-ui/core/esm/Container";
import CssBaseline from "@material-ui/core/esm/CssBaseline";
import { createStyles, makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useMSAL } from 'auth/msalProvider';
import Footer from 'components/Footer/Footer';
import LoadingPage from 'components/LoadingPage/LoadingPage';
import Navigation from 'components/Navigation/Navigation';
import useHandleUser from 'hooks/user/useHandleUser';
const useStyles = makeStyles(theme => createStyles({
  content: {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(1)
    }
  }
}));

// Header and footer should be in here.
export default function Layout({
  children
}) {
  const {
    content
  } = useStyles();
  const {
    loading
  } = useMSAL();
  const user = useHandleUser();
  if (loading || !user) return /*#__PURE__*/React.createElement(LoadingPage, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CssBaseline, null), /*#__PURE__*/React.createElement(Navigation, null), /*#__PURE__*/React.createElement(Container, {
    maxWidth: "md",
    component: "main",
    className: content
  }, children), /*#__PURE__*/React.createElement(Container, {
    maxWidth: "md"
  }, /*#__PURE__*/React.createElement(Footer, null)));
}